import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { OrderDirection } from "../../common/enums";
import { AGENT_FILTER_INCLUSION_DEFAULTS, COMMON_AGENT_FILTER_QUERY_PARAMS } from "../agent/api";
import { ChinaCompetitionResultOrderByColumn, SloveniaCompetitionResultOrderByColumn } from "./enums";
import {
  ChinaCompetitionResultExportRequest,
  ChinaCompetitionResultFilterPageRequest,
  ChinaCompetitionResultFilterPageResult,
  SloveniaCompetitionResultExportRequest,
  SloveniaCompetitionResultFilterPageRequest,
  SloveniaCompetitionResultFilterPageResult,
} from "./types";

const FILTER_CHINA_COMPETITION_RESULTS = ApiRequestAdapter.create("/competitions/china", HttpMethod.GET);
const DOWNLOAD_CHINA_COMPETITION_RESULTS_EXPORT = ApiRequestAdapter.create(
  "/competitions/china/export",
  HttpMethod.GET,
);
const FILTER_SLOVENIA_COMPETITION_RESULTS = ApiRequestAdapter.create("/competitions/slovenia", HttpMethod.GET);
const DOWNLOAD_SLOVENIA_COMPETITION_RESULTS_EXPORT = ApiRequestAdapter.create(
  "/competitions/slovenia/export",
  HttpMethod.GET,
);

export const competitionApi = {
  filterChinaCompetitionResults: (
    request: ChinaCompetitionResultFilterPageRequest,
  ): AxiosPromise<ChinaCompetitionResultFilterPageResult> => {
    return apiService.get(FILTER_CHINA_COMPETITION_RESULTS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  downloadChinaCompetitionResultsExport: (request: ChinaCompetitionResultExportRequest): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_CHINA_COMPETITION_RESULTS_EXPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
      responseType: "blob",
    });
  },
  filterSloveniaCompetitionResults: (
    request: SloveniaCompetitionResultFilterPageRequest,
  ): AxiosPromise<SloveniaCompetitionResultFilterPageResult> => {
    return apiService.get(FILTER_SLOVENIA_COMPETITION_RESULTS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  downloadSloveniaCompetitionResultsExport: (request: SloveniaCompetitionResultExportRequest): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_SLOVENIA_COMPETITION_RESULTS_EXPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
      responseType: "blob",
    });
  },
};

export const DEFAULT_CHINA_COMPETITION_QUERY_PARAMS: Required<ChinaCompetitionResultFilterPageRequest> = {
  ...COMMON_AGENT_FILTER_QUERY_PARAMS,
  ...AGENT_FILTER_INCLUSION_DEFAULTS.NONE_INCLUDED,
  orderBy: [ChinaCompetitionResultOrderByColumn.TOTAL_POINTS],
  orderDirections: [OrderDirection.DESC],
};

export const DEFAULT_SLOVENIA_COMPETITION_QUERY_PARAMS: Required<SloveniaCompetitionResultFilterPageRequest> = {
  ...COMMON_AGENT_FILTER_QUERY_PARAMS,
  ...AGENT_FILTER_INCLUSION_DEFAULTS.NONE_INCLUDED,
  orderBy: [SloveniaCompetitionResultOrderByColumn.RANKING],
  orderDirections: [OrderDirection.ASC],
};
